import { useCallback } from 'react';
import { appStore } from '../store/mobx/app.store';

const useAlert = () => {
  const { setAlert, removeAlert } = appStore;

  const showAlert = useCallback((message, status, callbackFn = undefined) => {
    setAlert(message, status, callbackFn);
  }, []);
  const closeAlert = useCallback(() => removeAlert(), []);

  return {
    showAlert,
    closeAlert,
  };
};

export default useAlert;
